import React from 'react';
import BaseModel from "../base_model.js.jsx";
import I18n from "../../base/i18n.js.jsx";
import uuidv4 from 'uuid/v4';
import UploadButton from "../../base/buttons/upload_button.js.jsx";
import { DownloadableDocumentModel } from "./downloadable_document_model.js.jsx";
import { TopBarHeight } from "../../admin/constants.js.jsx";

class rawDownloadableModel extends BaseModel {

  rawListFields() {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
      },
      {
        name: "documentsCount",
        displayName: this.fieldDisplayName("documentsCount"),
        type: "text",
      },
      {
        name: "subscribersCount",
        displayName: this.fieldDisplayName("subscribersCount"),
        type: "text",
      },
    ]
  }

  rawFormFields(item = undefined) {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        required: true,
        forceNextLine: true
      },
      {
        name: "headline",
        displayName: this.fieldDisplayName("headline"),
        type: "text",
        required: true,
        forceNextLine: true
      },
      {
        name: "content",
        displayName: this.fieldDisplayName("content"),
        type: "WYSIWYG",
        weight: 12,
        viewportTopOffset: parseInt(TopBarHeight)
      },
      {
        name: "sendEmail",
        displayName: this.fieldDisplayName("sendEmail"),
        type: "boolean"
      },
      {
        name: "documents",
        type: "nestedModelsArray",
        model: DownloadableDocumentModel,
        weight: 12,
        itemWeight: 6,
        allowDragDrop: false,
        allowDelete: true,
        defaultItem: (items) => {
          return {
            clientId: uuidv4(),
            loading: true,
            showInConfirmationPage: true,
            attachToEmail: true
          }
        },
        addButtonFunc: (items, defaultItem, onAdd) => {
          const onChange = (files) => {
            let newItems = Object.keys(files).map((index) => {
              let file = files[index];
              return {
                ...defaultItem(items),
                name: file.name,
                pdf: {
                  file: file
                }
              }
            })
            onAdd(newItems)
          }
          return <UploadButton key = "upload"
                               multiple = { true }
                               text = { I18n.t("action.upload_files") }
                               onChange = { onChange }
                               accept = { "application/pdf" }/>
        }
      },
    ]
  }

  displayValue(item) {
    if(!item) {
      return "";
    }
    if(!item.slug) {
      return I18n.t(`${this.i18nScope()}.new`);
    }
    if(!item.name) {
      return `${I18n.t(`${this.i18nScope()}.name`, {count: 1} )} ${item.slug}`;
    }
    return item.name;
  }

  i18nScope() {
    return "model.downloadables.downloadable";
  }

  value(item) {
    if(!item) {
      return undefined;
    }
    return item.slug;
  }

}
const DownloadableModel = new rawDownloadableModel();

export { rawDownloadableModel, DownloadableModel }
